import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import MenuPersonasSSV from './MenuPersonasSSV';
import { useAuth } from '../../Auth/AuthContext';
import { Card, CardHeader, CardBody, CardFooter, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import { FaSave, FaEraser, FaArrowAltCircleRight, FaCalendar } from 'react-icons/fa';
import { useForm, Controller } from 'react-hook-form';
import CargandoSpinner from '../Utils/CargandoSpinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

// CustomInput moved outside of Persona for best practices and prop validation
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
        <FaCalendar />
    </button>
));

export default function DatosBasicos() {
    const { token, rol } = useAuth();
    const { idEncuesta, idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [edad, setEdad] = useState('');
    const [tiposIdentificacion, setTiposIdentificacion] = useState([]);
    const [estadosCiviles, setEstadosCiviles] = useState([]);
    const [etnias, setEtnias] = useState([]);
    const [causasDiscapacidad, setCausasDiscapacidad] = useState([]);
    const [formPreloaded, setFormPreloaded] = useState(null);
    const [parentescos, setParentescos] = useState([]);
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const fetchData = async (idPersona, idEncuesta) => {
        let url = `/encuestassv/datosbasicos/obtenerdatosbasicospersona`;
        let obj = { idPersona: idPersona, idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setEtnias(result.etnias);
            setEstadosCiviles(result.estadoCivil);
            setTiposIdentificacion(result.tiposIdentificacion);
            setParentescos(result.parentescos);
            setCausasDiscapacidad(result.causasDiscapacidad);
            setFormPreloaded(result.DatosBasicosPersona);

            
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos básicos de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };    
    function CalcularEdad(date){
        setEdad(moment().diff(date, 'years'));
    }
    const resetForm = (data) => {
        if (data) {
            reset((prevValues) => ({
                ...prevValues,
                id: data.id || '',
                consFichaId: data.consFichaId || '',
                datosBasicosNombre: data.datosBasicosNombre || '',
                datosBasicosNombre2: data.datosBasicosNombre2 || '',
                datosBasicosApellido: data.datosBasicosApellido || '',
                datosBasicosApellido2: data.datosBasicosApellido2 || '',
                datosBasicosTipoDocumento: Number.parseInt(data.datosBasicosTipoDocumento) || '',
                datosBasicosCuentaConDocumento: data.datosBasicosCuentaConDocumento || '',
                datosBasicosNumeroDocumento: data.datosBasicosNumeroDocumento || '',
                datosBasicosDocumentoCorrespondeConEdad: data.datosBasicosDocumentoCorrespondeConEdad || '',
                datosBasicosDocumentoLegible: data.datosBasicosDocumentoLegible || '',
                datosBasicosFechaNacimiento: data.datosBasicosFechaNacimiento || '',
                datosBasicosParentesco: Number.parseInt(data.datosBasicosParentesco) || '',
                datosBasicosEstadoCivil: data.datosBasicosEstadoCivil || '',
                datosBasicosLibretaMilitar: data.datosBasicosLibretaMilitar || '',
                datosBasicosEstadoRuv: data.datosBasicosEstadoRuv || '',
                datosBasicosSisben: data.datosBasicosSisben || '',
                datosBasicosObservacion: data.datosBasicosObservacion || '',
                datosDiferencialesEdad: data.datosDiferencialesEdad || '',
                datosDiferencialesSexo: data.datosDiferencialesSexo || '',
                datosDiferencialesLgbti: data.datosDiferencialesLgbti || '',
                datosDiferencialesEtnia: data.datosDiferencialesEtnia || '',
                datosDiferencialesDiscapacidad1: data.datosDiferencialesDiscapacidad1 || 0,
                datosDiferencialesDiscapacidad2: data.datosDiferencialesDiscapacidad2 || 0,
                datosDiferencialesDiscapacidad3: data.datosDiferencialesDiscapacidad3 || 0,
                datosDiferencialesDiscapacidad4: data.datosDiferencialesDiscapacidad4 || 0,
                datosDiferencialesDiscapacidad5: data.datosDiferencialesDiscapacidad5 || 0,
                datosDiferencialesDiscapacidad6: data.datosDiferencialesDiscapacidad6 || 0,
                datosDiferencialesDiscapacidad7Terminal: data.datosDiferencialesDiscapacidad7Terminal || 0,
                datosDiferencialesDiscapacidad8: data.datosDiferencialesDiscapacidad8 || 0,
                datosDiferencialesDiscapacidadConsecuenciaHechoVictimizant: data.datosDiferencialesDiscapacidadConsecuenciaHechoVictimizant || '',
                datosDiferencialesMujerGestanteLactante: data.datosDiferencialesMujerGestanteLactante || 0,
                datosDiferencialesFechaGestancia: data.datosDiferencialesFechaGestancia || '',
                datosDiferencialesFechaLactancia: data.datosDiferencialesFechaLactancia || ''
            }))
            CalcularEdad(data.datosBasicosFechaNacimiento);
        }
    }
    useEffect(() => {
        if (formPreloaded && parentescos.length > 0 && tiposIdentificacion.length > 0) {
            resetForm(formPreloaded);
            setFormPreloaded(null);
        }
    }, [formPreloaded, setFormPreloaded, resetForm, parentescos, tiposIdentificacion]);
    useEffect(() => {
        fetchData(idPersona, idEncuesta);
    }, [idPersona, idEncuesta]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function GuardarDatosBasicos() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/datosbasicos/guardardatosbasicospersona`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos básicos de la persona.');
            }
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos básicos de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    

    }
    
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Personas</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Datos b&aacute;sico</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando}></CargandoSpinner>
            <section className="content">
                <div className="container-fluid">
                    <MenuPersonasSSV idPersona={idPersona} idEncuesta={idEncuesta}></MenuPersonasSSV>
                    <hr />
                    <Form onSubmit={handleSubmit(GuardarDatosBasicos)}>
                        <Card>
                            <CardHeader>
                                <h2>Para cada integrante de la familia</h2>
                                <b>Aplica para todas las personas del hogar. Para menores de 15 años, contesta el informante idoneo.</b>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Form.Label htmlFor="txtid_persona">Id persona</Form.Label>
                                            <Form.Control
                                                readOnly 
                                                id="id" 
                                                placeholder="Id persona" 
                                                type="text"
                                                {...register("id")}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                    <h6><b>1. Nombre(s) y Apellido(s)</b></h6> 
                                    <p>Nota: Antes de registrar a los miembros del hogar sondee que al menos uno de ellos est&eacute; inscrito en el RUPD/RUV</p>
                                    </Col>
                                </Row>
                                <Row>  
                                    <Col md={3}>
                                        <FormGroup>
                                        <Form.Label htmlFor="datosBasicosNombre">Primer nombre</Form.Label>
                                        <Form.Control 
                                            id="datosBasicosNombre" 
                                            placeholder="Nombre" 
                                            type="text" 
                                            {...register("datosBasicosNombre", { required: true })}/>
                                            {errors.datosBasicosNombre && <span style={{color: "red"}}>Este campo es requerido</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                        <Form.Label htmlFor="datosBasicosNombre2">Segundo nombre</Form.Label>
                                        <Form.Control 
                                            id="datosBasicosNombre2" 
                                            placeholder="Segundo nombre" 
                                            type="text"
                                            {...register("datosBasicosNombre2")}/>
                                        </FormGroup>  
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                        <Form.Label htmlFor="datosBasicosApellido">Primer apellido</Form.Label>
                                        <Form.Control 
                                            id="datosBasicosApellido" 
                                            placeholder="Apellido" 
                                            type="text" 
                                            {...register("datosBasicosApellido", { required: true })}/>
                                        {errors.datosBasicosApellido && <span style={{color: "red"}}>Este campo es requerido</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                        <Form.Label htmlFor="datosBasicosApellido2">Segundo apellido</Form.Label>
                                        <Form.Control 
                                            id="datosBasicosApellido2" 
                                            placeholder="Segundo Apellido" 
                                            type="text" 
                                            {...register("datosBasicosApellido2")}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>2. ¿Qu&eacute; tipo de documento de identificación tiene...?</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosTipoDocumento" 
                                            style={{width: "100%"}} 
                                            {...register("datosBasicosTipoDocumento", { required: true })}>
                                        <option value="0" hidden ></option>
                                        {tiposIdentificacion.map((tipo) => (
                                            <option key={tipo.id} value={tipo.id}>{tipo.str_tipoidentificacion}</option>
                                        ))}
                                        </Form.Control>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label htmlFor="datosBasicosNumeroDocumento">3. N&uacute;mero de documento de identificación</Form.Label>
                                        <Form.Control 
                                            id="datosBasicosNumeroDocumento" 
                                            placeholder="Identificacion" 
                                            type="text" 
                                            {...register("datosBasicosNumeroDocumento", { required: true })}/>
                                        <p>Nota: Si no conoce el n&uacute;mero, coloque 98</p>
                                        {errors.datosBasicosNumeroDocumento && <span style={{color: "red"}}>Este campo es requerido</span>}
                                    </FormGroup>
                                    <div className="dersuperado">
                                        <button id="identificacionseguimiento" type="button" className="btn btn-primary btn-xs" data-toggle="modal" data-target="#modal-seguimientoderecho">
                                        Superación del derecho
                                        </button>
                                    </div>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>4. ¿...cuenta con el documento de identificación?</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosCuentaConDocumento" 
                                            style={{width: "100%"}} 
                                            aria-hidden="true"
                                            {...register("datosBasicosCuentaConDocumento", { required: true })}
                                            >
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        <p>Nota: Solicite mostrar el documento</p>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>5. ¿Corresponde el documento de identificación con la edad?</Form.Label>
                                        <Form.Control as="select" 
                                        id="datosBasicosDocumentoCorrespondeConEdad" style={{width: "100%"}} aria-hidden="true" {...register("datosBasicosDocumentoCorrespondeConEdad", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        <p>Nota: Entre 0 y 6 años RC, entre 7 y 17 años TI, Mayores de edad CC</p>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>6. ¿El documento de identidad est&aacute; legible?</Form.Label>
                                        <Form.Control as="select" id="datosBasicosDocumentoLegible" style={{width: "100%"}} aria-hidden="true" {...register("datosBasicosDocumentoLegible", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        <p>Nota: Es ilegible cuando el documento est&aacute; borroso o quebrado</p>
                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>7. ¿Cu&aacute;l es la fecha de nacimiento de...?</Form.Label>
                                        <Controller
                                            control={control}
                                            name="datosBasicosFechaNacimiento"
                                            rules={{ required: "Seleccione fecha nacimiento" }}
                                            render={({ field }) => (
                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => {field.onChange(date); CalcularEdad(date);}}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value ? new Date(`${field.value}`) : null}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                </div>
                                            )}
                                        />
                                        {errors.datosBasicosFechaNacimiento && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                        
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                        <Form.Label htmlFor="Edad">8. Edad</Form.Label>
                                        <Form.Control id="Edad" placeholder="Edad" type="text" value={edad} readOnly />
                                        </FormGroup>  
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>9. El parentesco de … con la persona jefe del hogar es:</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosParentesco"
                                            style={{width: "100%"}} 
                                            aria-hidden="true"
                                            {...register("datosBasicosParentesco", { required: true })}>
                                        <option value="0" hidden ></option>
                                        {parentescos.map((parentesco) => (
                                            <option key={parentesco.id} value={parentesco.id}>{parentesco.str_parentesco}</option>
                                        ))}
                                        {errors.datosBasicosParentesco && <p style={{color: 'red'}}>Seleccione parentesco</p>}
                                        </Form.Control>
                                        <p>Nota: NO acepte como jefe de hogar a persona menor de 10 años</p>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>10. Estado civil:</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosEstadoCivil" 
                                            style={{width: "100%"}}
                                            {...register("datosBasicosEstadoCivil", { required: true })}>
                                        <option value="0" hidden ></option>
                                        {estadosCiviles.map((estadoCivil) => (
                                            <option key={estadoCivil.id} value={estadoCivil.id}>{estadoCivil.str_estadocivil}</option>
                                        ))}

                                        </Form.Control>
                                        {errors.datosBasicosEstadoCivil && <p style={{color: 'red'}}>Seleccione estado civil</p>}
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>11. ¿...tiene libreta militar?</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosLibretaMilitar" 
                                            style={{width: "100%"}}
                                            {...register("datosBasicosLibretaMilitar", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. S&iacute;</option>
                                        <option value="2">2. En tr&aacute;mite</option>
                                        <option value="3">3. No</option>
                                        <option value="4">4. No requiere</option>
                                        </Form.Control>
                                        {errors.datosBasicosLibretaMilitar && <p style={{color: 'red'}}>Seleccione opción</p>}
                                        <div className="dersuperado">
                                        <button id="libretamilitarseguimiento" type="button" className="btn btn-primary btn-xs" data-toggle="modal" data-target="#modal-seguimientoderecho">
                                            Superación del derecho
                                        </button>
                                        </div>
                                        <p>Nota 1: Aplica solo para los hombres entre 18 y 50 años de edad. </p>
                                        <p>Nota 2: Si tiene libreta provisional o est&aacute; vencida, marque "Si"</p>
                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>  
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>12. ¿Estado RUV?</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosEstadoRuv" 
                                            style={{width: "100%"}}
                                            {...register("datosBasicosEstadoRuv", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Incluido</option>
                                        <option value="2">2. No Incluido</option>
                                        <option value="3">3. Valoracion</option>
                                        <option value="4">4. No Victimas</option>
                                        </Form.Control>
                                        {errors.datosBasicosEstadoRuv && <p style={{color: 'red'}}>Seleccione opción</p>}
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>13. Tiene SISBEN en Medellin</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosBasicosSisben" 
                                            style={{width: "100%"}}
                                            {...register("datosBasicosSisben", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. No sabe</option>
                                        </Form.Control>
                                        {errors.datosBasicosSisben && <p style={{color: 'red'}}>Seleccione opción</p>}
                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                    <FormGroup>
                                        <Form.Label>Observaciones</Form.Label>
                                        <Form.Control as="textarea" 
                                            id="datosBasicosObservacion" rows="3" placeholder="En torno a la conformación del grupo familiar."
                                            {...register("datosBasicosObservacion")}></Form.Control>
                                    </FormGroup>  
                                    </Col> 
                                </Row>
                                <Row>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>14. Sexo</Form.Label>
                                        <Form.Control as="select" 
                                        id="datosDiferencialesSexo" style={{width: "100%"}}
                                        {...register("datosDiferencialesSexo", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Hombre</option>
                                        <option value="2">2. Mujer</option>
                                        </Form.Control>
                                        {errors.datosDiferencialesSexo && <p style={{color: 'red'}}>Seleccione opción</p>}
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>15. ¿Alg&uacute;n miembro del hogar tiene condicion de género diversa? (OSIEGD)</Form.Label>
                                        <Form.Control as="select" id="datosDiferencialesLgbti" style={{width: "100%"}}
                                        {...register("datosDiferencialesLgbti", { required: true })}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. NS/NR</option>
                                        </Form.Control>
                                        {errors.datosDiferencialesLgbti && <p style={{color: 'red'}}>Seleccione opción</p>}
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>16. De acuerdo con su cultura, pueblo o rasgos f&iacute;sicos, ... se reconoce como:</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosDiferencialesEtnia" 
                                            style={{width: "100%"}}
                                            {...register("datosDiferencialesEtnia", { required: true })}>
                                        <option value="0" hidden ></option>
                                        {etnias.map((etnia) => (
                                            <option key={etnia.id} value={etnia.id}>{etnia.str_etnia}</option>
                                        ))}
                                        </Form.Control>
                                        {errors.datosDiferencialesEtnia && <p style={{color: 'red'}}>Seleccione opción</p>} 
                                    </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                    <FormGroup>
                                        <Form.Label>17. ¿Alg&uacute;n miembro del hogar tiene algún tipo de discapacidad? (Selección multiple)</Form.Label>
                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 10 }}>
                                            <ul className="list-unstyled mb-0">
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>1. Fisica miembros superiores</span>
                                                        <input 
                                                            id="datosDiferencialesDiscapacidad1" 
                                                            type="checkbox" 
                                                            style={{ margin: 0 }} 
                                                            {...register("datosDiferencialesDiscapacidad1")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>2. Fisica miembros inferiores</span>
                                                        <input id="datosDiferencialesDiscapacidad2" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad2")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>3. Sensorial visual</span>
                                                        <input id="datosDiferencialesDiscapacidad3" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad3")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>4. Sensorial auditiva</span>
                                                        <input id="datosDiferencialesDiscapacidad4" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad4")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>5. Psiquica</span>
                                                        <input id="datosDiferencialesDiscapacidad5" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad5")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>6. Intelectual</span>
                                                        <input id="datosDiferencialesDiscapacidad6" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad6")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>7. Enfermedad crónica o terminal</span>
                                                        <input id="datosDiferencialesDiscapacidad7Terminal" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad7Terminal")}/>
                                                    </Form.Label>
                                                </li>
                                                <li>
                                                    <Form.Label style={{ fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                        <span>8. Ninguna (Pase a pregunta 19)</span>
                                                        <input id="datosDiferencialesDiscapacidad8" type="checkbox" style={{ margin: 0 }} {...register("datosDiferencialesDiscapacidad8")}/>
                                                    </Form.Label>
                                                </li>
                                            </ul>
                                        </div>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>18. Aplica sólo para cada miembro del Hogar que SI tenga alguna discapacidad.</Form.Label>
                                        <Form.Control as="select" 
                                            id="datosDiferencialesDiscapacidadConsecuenciaHechoVictimizant" 
                                            style={{width: "100%"}} {...register("datosDiferencialesDiscapacidadConsecuenciaHechoVictimizant")}>
                                        <option value="0" hidden ></option>
                                        {causasDiscapacidad.map((causa) => (
                                            <option key={causa.id} value={causa.id}>{causa.dis_causa}</option>
                                        ))}
                                        </Form.Control>
                                        <p>Nota: Aplica sólo para cada miembro del hogar que SI tenga alguna discapacidad.</p>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>19. ¿Actualmente alguna mujer del grupo familiar est&aacute;?</Form.Label>
                                        <Form.Control as="select" id="datosDiferencialesMujerGestanteLactante" style={{width: "100%"}} {...register("datosDiferencialesMujerGestanteLactante")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Gestando</option>
                                        <option value="2">2. Lactando</option>
                                        <option value="3">3. Ambas</option>
                                        <option value="4">4. Ninguna (PASE AL CAPITULO "B. SALUD")</option>
                                        </Form.Control>
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>20. Fecha en la que comenzó a gestar?</Form.Label>
                                        <Controller
                                            control={control}
                                            name="datosDiferencialesFechaGestancia"
                                            render={({ field }) => (
                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => {field.onChange(date);}}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value ? new Date(`${field.value}`) : null}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                </div>
                                            )}
                                        />
                                        {errors.datosDiferencialesFechaGestancia && <p style={{color: 'red'}}>Seleccione fecha gestancia</p>}
                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                        <Form.Label>21. Fecha en la que comenzó a lactar?</Form.Label>
                                        <Controller
                                            control={control}
                                            name="datosDiferencialesFechaLactancia"
                                            render={({ field }) => (
                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => {field.onChange(date);}}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value ? new Date(`${field.value}`) : null}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                </div>
                                            )}
                                        />
                                        {errors.datosDiferencialesFechaLactancia && <p style={{color: 'red'}}>Seleccione fecha lactancia</p>}
                                    </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                                    <Button type="submit" id="btnPersonaBasicosGuardar" className="btn btn-primary">
                                        <FaSave />
                                        Guardar
                                    </Button>
                                    <Button id="borrarpersona" className="btn btn-danger">
                                        <FaEraser />
                                        Borrar
                                    </Button>
                                    <Button 
                                        id="btnPersonaBasicosCancel" 
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            globalThis.location.href = `/encuestassv/id/${idEncuesta}`;
                                        }
                                        }>
                                        <FaArrowAltCircleRight />
                                        Volver
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Form>
                    
                    
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }